import styled from 'styled-components';

export const ButtonElement = styled.button`

    @media (max-width: 700px){
        font-size: .8rem;
        border-width: 3px;
        padding: 4px 8px;
    }
`;